import { graphql, useStaticQuery } from 'gatsby';

const useTradingPoints = () => {
  const { allContentfulTradingPoint, allContentfulCity } = useStaticQuery(graphql`
    query MyQuery {
      allContentfulTradingPoint {
        nodes {
          contentful_id
          address
          city {
            city
            value
          }
          embedMap {
            embedMap
          }
          img {
            gatsbyImageData(layout: FULL_WIDTH, quality: 90)
          }
          info {
            info
          }
          linkMap
          marker {
            lat
            lon
          }
          name
          openDays
          schedule
          segmentName
          zone {
            name
            value
          }
          spaceId
        }
      }

      allContentfulCity {
        nodes {
          city
          id
          value
          zones {
            name
            value
          }
          defaultTradingPoint {
            lat
            lon
          }
        }
      }
    }
  `);

  const omitObjectIfMissingProp = arrayOfObjects =>
    arrayOfObjects.filter(obj => Object.values(obj).every(value => typeof value !== 'undefined'));

  return [omitObjectIfMissingProp(allContentfulTradingPoint.nodes), omitObjectIfMissingProp(allContentfulCity.nodes)];
};

export default useTradingPoints;
